import { GroupSecurity } from '@quromedical/fhir-common';
import { withPermissions } from 'components/groups';
import { OrganizationListScreen } from 'screens/organization';

export default withPermissions(OrganizationListScreen, [
  GroupSecurity.OrganizationRead,
]);
